// TODO Add error handling for blocked location update
// TODO Add method for detecting if location is enabled
// TODO Store stack of location updates in Vuex
// TODO Set a boolean in Vuex for lastUpdateSuccessful
import geoLocationServices from '@/utils/geoLocationServices'

let GeoLocation = null

import {
  FETCH_LOCATION,
  SET_LAST_UPDATE_STATUS,
  SET_LOCATION,
  SET_TRACKING
} from './mutation-types'

// This will continuously run in the background
// so it only needs to be called once on the application's
// initial load. Sets up the Geolocation service. Future
// calls can call the stop/start methods.
let fetchLocation = ({commit}) => {
  // Reset the initial location setting
  commit(SET_LAST_UPDATE_STATUS, {
    success: false
  })

  // Callback for location updates
  let successCallback = (location) => {
    commit(FETCH_LOCATION, location)
    commit(SET_LAST_UPDATE_STATUS, {
      success: true
    })
  }
  let errorCallback = (error) => {
    commit(SET_LAST_UPDATE_STATUS, {
      success: false,
      error: error
    })
  }

  let GeoLocationService = geoLocationServices.BrowserGeolocationService
  GeoLocation = new GeoLocationService(successCallback, errorCallback)
  GeoLocation.getPosition()
}

// Stop tracking
let stopTracking = ({commit}) => {
  GeoLocation.stopTracking()
  commit(SET_TRACKING, false)
}

// Start tracking
let startTracking = ({commit}) => {
  GeoLocation.startTracking()
  commit(SET_TRACKING, true)
}

// For one off location requests
// eslint-disable-next-line
let getCurrentPosition = ({commit}, callback) => {
  GeoLocation.getPosition()
  if (callback) {
    callback()
  }
}

let locationEnabled = () => {
  return GeoLocation.locationEnabled
}

let setLocation = function ({ commit }, location) {
  return commit(SET_LOCATION, location)
}

export {
  fetchLocation,
  locationEnabled,
  setLocation,
  getCurrentPosition,
  stopTracking,
  startTracking
}
